export default __webpack_public_path__ + "static/media/pic68.24729501.jpg";